import { render } from "./addParentMenu.vue?vue&type=template&id=3d19c79b&scoped=true"
import script from "./addParentMenu.vue?vue&type=script&lang=js"
export * from "./addParentMenu.vue?vue&type=script&lang=js"

import "./addParentMenu.vue?vue&type=style&index=0&id=3d19c79b&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d19c79b"]])

export default __exports__